import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import { SignOut } from "@phosphor-icons/react";

const COMPANY_LOGO = process.env.REACT_APP_COMPANY_LOGO;
const COMPANY_NAME = process.env.REACT_APP_COMPANY_NAME || "Vision AcryGlas";

export const TopHeader = ({ title, subtitle, showLogout = false, children }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <div className="top-bar" data-testid="top-header">
      {/* Logo Bar */}
      <div className="flex items-center justify-between mb-3 pb-3 border-b border-[#E5E7EB]">
        <div className="flex items-center gap-3">
          <img 
            src={COMPANY_LOGO} 
            alt={COMPANY_NAME} 
            className="h-10 object-contain"
            data-testid="header-company-logo"
          />
        </div>
        {showLogout && (
          <button
            onClick={handleLogout}
            className="p-2 text-[#4B5563] hover:text-[#0A0A0A] transition-colors"
            data-testid="logout-button"
          >
            <SignOut size={24} weight="bold" />
          </button>
        )}
      </div>
      
      {/* Page Title */}
      <div className="flex items-center justify-between">
        <div>
          {subtitle && <p className="overline">{subtitle}</p>}
          <h1 className="top-bar-title">{title}</h1>
        </div>
        {children}
      </div>
    </div>
  );
};
